export default __webpack_public_path__ + "static/media/Mobile-01.b605facf.jpg";